export default "__VITE_ASSET__DOWJCDtp__"